<template>
  <div class="text-center">
    
    <MultiSelect
      ref="multiSelectRef"
      v-model="selectedArray"
      :options="options"
      idField="styleid"
      labelField="stylename"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxSelections="1"
      buttonClass="min-h-14"
    >
      <template #after-options>
        <li class="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer flex items-center" @click="handleCreate" role="option">
          <svg class="w-4 h-4 mr-4" fill="currentColor" viewBox="0 0 20 20"><path d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"/></svg>
          <span>{{ createButtonText }}</span>
        </li>
      </template>
    </MultiSelect>
    <p v-if="error === true" class="text-error text-xs mt-1">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import MultiSelect from '@/components/MultiSelect.vue';
import { defineProps, defineEmits, computed, ref, toRefs } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  modelValue: { type: [Array, String], default: () => [] },
  options: { type: Array, default: () => [] },
  error: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});
const { modelValue, options, error, errorMessage, disabled } = toRefs(props);

const emit = defineEmits(['update:modelValue', 'create-new-style']);

const { t } = useI18n();
const placeholder = t('agentStyleSelect.placeholder', 'Select Styles');
const createButtonText = t('agentStyleSelect.createButton', 'Create New Style');


const selectedArray = computed({
  get() {
    if (Array.isArray(modelValue.value) === true) return modelValue.value;
    if (modelValue.value !== undefined && modelValue.value !== null && modelValue.value !== '') return [modelValue.value];
    return [];
  },
  set(val) {
    if (Array.isArray(val) && val.length > 0) emit('update:modelValue', val[0]);
    else emit('update:modelValue', '');
  }
});

const multiSelectRef = ref(null);

function handleCreate() {
  emit('create-new-style');
  if (multiSelectRef.value !== null) multiSelectRef.value.closeDropdown();
}
</script>